export const userConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    
    LOGOUT: 'USERS_LOGOUT',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    REQUEST_FORGOT_PASSWORD:'REQUEST_FORGOT_PASSWORD',
    RECEIVE_FORGOT_PASSWORD:'RECEIVE_FORGOT_PASSWORD',
    FORGOT_PASSWORD_ERROR:'FORGOT_PASSWORD_ERROR',

    REQUEST_SET_PASSWORD:'REQUEST_SET_PASSWORD',
    RECEIVE_SET_PASSWORD:'RECEIVE_SET_PASSWORD',
    SET_PASSWORD_ERROR:'SET_PASSWORD_ERROR',
};



// WEBPACK FOOTER //
// ./src/_constants/user.constants.js